module.exports = __webpack_public_path__ + "img/tmp3.c1d7b564.jpg";